// 根据不同的环境更改不同的baseUrl
let baseUrl = process.env.VUE_APP_BASE_API

if (process.env.NODE_ENV === 'development') {
  baseUrl = ''
} else if (process.env.NODE_ENV === 'production') {
  baseUrl = '' // 生产地址
}
export { baseUrl }

